import { Component, Input } from '@angular/core';
import { ComponentBase } from '../../_utils/component.base';
import { HiddenModalTypesEnum } from '../../_utils/unums/hidden-modal-types.enum';
import { ModuleEnum } from '../../_utils/unums/module.enum';

@Component({
  selector: 'app-hide-modal',
  templateUrl: './hide-modal.component.html',
  styleUrls: ['./hide-modal.component.scss'],
})
export class HideModalComponent extends ComponentBase {
  @Input()
  modalType: HiddenModalTypesEnum;
  @Input()
  module: ModuleEnum | string;

  constructor() {
    super();
  }

  async changeModalTypeHandler(event) {
    const hiddenItems: any = (await this.storage.get('hidden-modals')) || {};
    if (!hiddenItems[this.module]) {
      hiddenItems[this.module] = {};
    }
    hiddenItems[this.module][this.modalType] = event.detail.checked;
    this.storage.set('hidden-modals', hiddenItems).then();
  }
}
